export default {
    chart: {
        colors: ['#005180', '#5796ba', '#aed4eb', '#2E93fA', '#66DA26', '#546E7A', '#0B9A18', '#FF9800', '#9933ff', '#09370E', '#FF0000']
    },
    const: {
        appVersion: {key: 'app-version', label: 'Phiên bản ứng dụng', group: 'Thư viện'},
        language: {key: 'language', label: 'Ngôn ngữ', group: 'Thư viện'},
        country: {key: 'country', label: 'Quốc gia', group: 'Thư viện'},
        race: {key: 'race', label: 'Dân tộc', group: 'Thư viện'},
        dataFieldGroup: {key: 'data-f-group', label: 'Phân loại rác', group: 'Thư viện dữ liệu'},
    },
    etc: [
        {key: 'site-url', label: 'Tên miền ứng dụng (Backend)', type: 'TEXT'},
        {key: 'site-frontend-url', label: 'Tên miền cho người dùng (Frontend)', type: 'TEXT'},
        {key: 'site-media-url', label: 'Tên miền hình ảnh (Media)', type: 'TEXT'},
        {key: 'site-name', label: 'Tên ứng dụng', type: 'TEXT'},
        {key: 'site-color', label: 'Màu chính', type: 'TEXT', view: 'color'},
        {key: 'site-color-bold', label: 'Màu đậm', type: 'TEXT', view: 'color'},
        {key: 'site-color-hover', label: 'Màu hover', type: 'TEXT', view: 'color'},
    ],
    gender: [
        {value: null, text: "Chọn giới tính"},
        {value: 0, text: "Nam"},
        {value: 1, text: "Nữ"},
        {value: 2, text: "Khác"}
    ],
    post: {
        templateOptions: [
            {value: null, text: "Mặc định"},
        ],
        pageOptions: [
            {value: 'main', text: "Website chính thức"},
//            {value: 'hn', text: "Hà Nội"},
            {value: 'ha', text: "Hội An"},
//            {value: 'dn', text: "Đà Nẵng"},
        ],
        formatOptions: [
            {value: "content", text: "Chuẩn nội dung", icon: 'fa fa-file-alt'},
            {value: "image", text: "Album ảnh", icon: 'far fa-images'},
        ],
        typeOptions: [
            {value: "cn", text: "Cá nhân"},
            {value: "tc", text: "Tổ chức"},
        ],
        statusOptions: [
            {value: 'private', text: "Bản nháp"},
            {value: 'public', text: "Công khai"},
        ],
        commentOptions: [
            {value: 'public', text: "Mở bình luận"},
            {value: 'private', text: "Khoá bình luận"},
        ],
        langOptions: [
            {value: "vi", text: "Tiếng Việt"},
            {value: "en", text: "Tiếng Anh"},
        ],
        groupOptions: [
            {value: 1, text: "Đề án bảo vệ môi trường"},
            {value: 2, text: "Chương trình và dự án"},
        ]
    },
    commentTypeOptions: [
        {value: 'news', text: "Tin tức và sự kiện"},
        {value: 'policy', text: "Quản lý và chính sách"},
    ],
    publicService: {
        statusOptions: [
            {value: 1, text: "Công khai"},
            {value: 0, text: "Khóa"},
        ],
        typeOptions: [
            {value: 1, text: "Thủ tục hành chính"},
            {value: 2, text: "Văn bản pháp luật"},
            {value: 3, text: "Cổng dịch vụ công trực tuyến"},
        ],
    },
    placeGreen: {
        typeOptions: [
            {value: 1, text: "Ẩm thực"},
            {value: 2, text: "Điểm lưu trú"},
            {value: 3, text: "Cơ sở sản xuất"},
            {value: 4, text: "Cơ sở kinh doanh"},
            {value: 5, text: "Làng nghề"},
            {value: 7, text: "Ngôi nhà xanh"},
            {value: 6, text: "Khác"},
        ]
    },
    monitoring: {
        typeOptions: [
            {value: null, text: "Chọn loại quan trắc"},
            {value: 1, text: "Quan trắc môi trường nước biển ven bờ"},
            {value: 2, text: "Quan trắc môi trường nước hồ"},
            {value: 3, text: "Quan trắc môi trường nước sông"},
            {value: 4, text: "Quan trắc môi trường nước ngầm"},
            {value: 5, text: "Quan trắc môi trường đất"},
            {value: 6, text: "Quan trắc dư lượng hóa chất bảo vệ thực vật trong đất"},
            {value: 7, text: "Quan trắc môi trường trầm tích"},
            {value: 8, text: "Quan trắc môi trường không khí"},
        ],
    }
};